import React, { useState } from "react";
import { Box } from "@mui/material";
import Sidebar from "./Sidebar2";
import Navbar from "./Navbar";
import { Outlet } from "react-router-dom";

import {
  Dashboard,
  Inventory2,
  People,
} from "@mui/icons-material";

const DashboardLayout: React.FC = () => {
  const [collapse, setCollapse] = useState(false);

  const menu = [
    { id: 1, label: "Dashboard", path: "/", icon: Dashboard },
    {
      id: 2,
      label: "Inventory",
      icon: Inventory2,
      children: [
        { id: 21, label: "Item Master", path: "/items" },
        { id: 22, label: "Category Management", path: "/category" },
      ],
    },
    { id: 3, label: "Customers", path: "/customers", icon: People },
  ];

  return (
    <>
      <style>{`
      .main-panel::-webkit-scrollbar { display: none !important; width: 0 !important; }
      .main-panel { -ms-overflow-style: none !important; scrollbar-width: none !important; }
    `}</style>
      <Box sx={{ display: "flex", height: "100vh", overflow: "hidden", background: "#1a1c22" }}>
        <Sidebar
          open={true}
          collapse={collapse}
          handleCollapse={() => setCollapse(!collapse)}
        />

        {}
        <Box
          className="main-panel"
          sx={{
            flexGrow: 1,
            ml: collapse ? "80px" : "260px",
            height: "100vh",
            borderTopLeftRadius: "20px",
            overflow: "hidden",
            overflowY: "auto",
            background: "#f9fafb",
          }}
        >
          <Navbar />
          <Box sx={{ pl: 2, pt: 2, pr: 2, background: "#f4f6f8", minHeight: "100%" }}>
            <Outlet />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default DashboardLayout;